module.exports = __webpack_public_path__ + "static/04-547d398a2eb476cbf0337b638a2c83e2.jpg";